import {EventEx} from '../../../data/Event';
import {SignalRService} from '../signal-r.service';
import {HubConnection} from '@microsoft/signalr';

export class SignalRCustomerConvertHandler {
    static instance: SignalRCustomerConvertHandler;
    connection: HubConnection;

    onReceive: EventEx = new EventEx();

    constructor(public signalRService: SignalRService) {
        this.signalRService = signalRService;
        SignalRCustomerConvertHandler.instance = this;
    }

  async hook(connection: HubConnection) {
    this.connection = connection;
    this.connection.on('CustomerConvertActivity', this.onCustomerConvertActivity);
    }

  onCustomerConvertActivity(json: string) {
        const data = JSON.parse(json);
        SignalRCustomerConvertHandler.instance.onReceive.emit(data);
    }
}
